import { Button, IButtonProps } from '@/components/ui/button'
import { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import { cn } from '@/utils/styles/cn'

interface AuthInlineNavigationProps extends IButtonProps {
    text: string
    ctaText: string
    className?: string
}

export const AuthInlineNavigation = ({
    text,
    ctaText,
    onClick,
    className,
    ...buttonProps
}: AuthInlineNavigationProps) => {
    const { clearErrors } = useFormContext()

    const handleClick = useCallback(
        (e: React.MouseEvent<HTMLButtonElement>) => {
            clearErrors()
            onClick?.(e)
        },
        [clearErrors, onClick]
    )

    return (
        <div className={cn('flex items-center mx-auto w-full justify-center', className)}>
            <p className="text-sm text-[#474747CC]">{text}</p>
            <Button
                variant="link"
                className="text-[#E57100] font-semibold text pl-2"
                onClick={handleClick}
                {...buttonProps}
            >
                {ctaText}
            </Button>
        </div>
    )
}
